<form [formGroup]="myForm" >
  <div class="bg-white rounded-lg py-3 mb-6">
    <div class="flex justify-between items-center mt-3 mb-6 px-6">
      <h1 class="font-semibold">{{ 'DETAILS' | translate }}</h1>
      <button class="bg-[#D9D9D9] rounded-full" (click)="profileMenu = !profileMenu">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <g clip-path="url(#clip0_1958_7961)">
            <path d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
              fill="#6C757D" />
          </g>
          <defs>
            <clipPath id="clip0_1958_7961">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>
    <div *ngIf="profileMenu" class="grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">

      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">
          {{ 'FULL_NAME' | translate }}
        </h1>
        <input type="text" class="w-full border p-2 rounded-md outline-none" [placeholder]="'PLACEHOLDER_ENTER' | translate"
          formControlName="name" />
      </div>

      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">{{ 'EMAIL_ID' | translate }}</h1>
        <input type="email" class="w-full border p-2 rounded-md outline-none" [placeholder]="'PLACEHOLDER_ENTER' | translate"
          formControlName="email" />
      </div>

      <!--  -->
      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">{{ 'MOBILE' | translate }}</h1>
        <input type="number" class="w-full border p-2 rounded-md outline-none" [placeholder]="'PLACEHOLDER_ENTER_MOBILE' | translate"
          formControlName="mobile" />
      </div> 
  
     
      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">{{ 'STATE' | translate }}</h1>
        <select class="w-full border p-2 rounded-md outline-none bg-white"
          formControlName="state" (change)="onStateChange()">
          <option value="">{{ 'SELECT_STATE' | translate }}</option>
          <option *ngFor="let state of states" [value]="state">{{ state }}</option>
        </select>
      </div>
      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">{{ 'DISTRICT' | translate }}</h1>
        <select class="w-full border p-2 rounded-md outline-none bg-white"
          formControlName="district" (change)="onDistrictChange()">
          <option value="">{{ 'SELECT_DISTRICT' | translate }}</option>
          <option *ngFor="let d of districtOptions" [value]="d">{{ d }}</option>
        </select>
      </div>
      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">{{ 'CITY' | translate }}</h1>
        <select class="w-full border p-2 rounded-md outline-none bg-white"
          formControlName="city">
          <option value="">{{ 'SELECT_CITY' | translate }}</option>
          <option *ngFor="let city of cityOptions" [value]="city">{{ city }}</option>
        </select>
      </div>
      
<div class="col-span-6 flex flex-col gap-2">
  <h1 class="font-semibold">{{ 'COUNTRY' | translate }}</h1>
  <input type="text" class="w-full border p-2 rounded-md outline-none" [placeholder]="'PLACEHOLDER_ENTER_COUNTRY' | translate"
    formControlName="country" />
</div>


      <div class="col-span-6 flex flex-col gap-2">
        <h1 class="font-semibold">{{ 'POSTAL_CODE' | translate }}</h1>
        <input [maxlength]="6" class="w-full border p-2 rounded-md outline-none" [placeholder]="'PLACEHOLDER_ENTER_POSTAL' | translate"
          formControlName="postal_code" />
      </div>
     



      <div class="col-span-6 flex gap-2">
        <div class="bg-white border-2 rounded-xl border-[#0058e9]">
          <div class="p-5 flex items-center justify-center">
            <div *ngIf="!imageurl" class="w-full">
              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 11.1L7 9.1L12.5 14.6L16 11.1L19 14.1V5H5V11.1ZM5 13.929V19H8.1L11.086 16.015L7 11.929L5 13.929ZM19 19H10.929L16 13.929L19 16.929V19ZM14 8.5C14 9.32843 14.6716 10 15.5 10C16.3284 10 17 9.32843 17 8.5C17 7.67157 16.3284 7 15.5 7C14.6716 7 14 7.67157 14 8.5Z"
                  fill="#525B69" />
              </svg>
            </div>
            <div class="h-30 w-40">
              <img *ngIf="imageurl" [src]="imageurl" [attr.alt]="'PROFILE_IMAGE_ALT' | translate" class="h-40 w-40" />
            </div>
          </div>
          <div class="bg-primary text-[10px] text-white py-3 px-4 rounded-b-lg py-1">
            <h1 class="text-center" style="font-size: 14px">{{ 'CHANGE_PICTURE' | translate }}</h1>
          </div>
        </div>

        <div class="flex gap-4">
          <div class="flex flex-col w-full justify-end">
            <button>
              <label for="fileInput" [attr.title]="'PROFILE_PHOTO_TOOLTIP' | translate"
                class="bg-primary text-white px-3 py-2 rounded-lg flex items-center cursor-pointer justify-center gap-2">
                <span class="flex">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_1977_10834)">
                      <path d="M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z" fill="#F5F5F5" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1977_10834">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                {{ 'PROFILE_UPLOAD' | translate }}
              </label>
            </button>

            <input type="file" id="fileInput" [attr.title]="'PROFILE_PHOTO_TOOLTIP' | translate"
              (change)="handleFileInput($event)" accept=".jpg,.jpeg,.png, .webp" style="display: none" />
            <span class="tooltip">{{ 'PROFILE_PHOTO_HINT' | translate }}</span>
          </div>


          <div *ngIf="errorMessage" class="file-error text-[#d60000] text-[14.241px]">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-white rounded-lg py-3 px-12 flex justify-end gap-4">
    <button (click)="saveProfile()" class="rounded-lg py-2 px-4 bg-primary text-white">
      {{ 'SAVE' | translate }}
    </button>

  </div>
</form>
